import PropTypes from 'prop-types'
import { convertMinutesToTimeString } from '@/modules/timetracking/util/time_helpers'

const EMPTY_PROP = '-'

export const DurationTimeCell = (props) => {
  const { value } = props
  return value ? convertMinutesToTimeString(value) : EMPTY_PROP
}

DurationTimeCell.propTypes = {
  value: PropTypes.any,
}

export default DurationTimeCell
